import { InjectionToken } from '@angular/core';

export type ToastClient = {
  success(message: string, durationMs?: number): void;
  error(message: string, durationMs?: number): void;
};

export const TOASTS = new InjectionToken<ToastClient>('TOASTS');
